const ErrorMessage = ({ errMsg }) => {
    return (
        <div className="error">{ errMsg }</div>
    );
}
 
export default ErrorMessage;